import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeto = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "keto",
	"data-name": "keto",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			className: "plan2plate-icon",
			cx: 2.2865362,
			cy: 22.223986,
			rx: 3.6895328,
			ry: 5.7450066,
			transform: "rotate(-58.28652)",
			id: "ellipse1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "plan2plate-icon",
			cx: 2.2865362,
			cy: 22.223986,
			rx: .41281483,
			ry: .81702942,
			transform: "rotate(-58.28652)",
			id: "ellipse2"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 24.999412,12.754436 -1.080515,1.748582 a 5.7278061,5.7278061 0 0 1 -4.451568,2.703691 2.1070758,2.1070758 0 0 0 -1.679468,0.970986 l -0.115085,0.18624 a 2.4682889,2.4682889 0 0 1 -3.503707,0.730161 2.5800928,2.5800928 0 0 1 -0.607983,-3.435353 l 0.07825,-0.08033 a 2.1070758,2.1070758 0 0 0 0.07528,-1.926534 5.7278061,5.7278061 0 0 1 0.426728,-5.190791 l 1.080513,-1.7485872",
			id: "path2"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 16.148044,19.466281 v 0 l -0.619714,0.968168 a 1.6512594,1.6512594 0 0 0 -0.07005,1.686706 1.7200619,1.7200619 0 0 1 -0.03157,1.774824 1.7200619,1.7200619 0 0 1 -2.980361,-0.04735 1.9006684,1.9006684 0 0 0 -1.551995,-0.959036 1.7200619,1.7200619 0 0 1 -1.3755733,-2.644352 1.7200619,1.7200619 0 0 1 1.5732183,-0.822181 1.6512594,1.6512594 0 0 0 1.497886,-0.804392 l 0.639358,-1.034663",
			id: "path3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M 11.313517,5.4488065 C 13.213825,9.1705671 12.035251,12.451596 8.993677,14.004607 5.9521011,15.557618 1.678985,15.022538 0.11235993,11.148475 -0.25282501,10.24542 -0.53648136,9.0126791 -0.29298955,6.7678721 -0.18058322,5.7315715 -0.57919026,4.583834 -0.74276778,3.6889161 -1.082848,1.8283682 0.11283632,0.10844955 1.3671203,-0.53198089 2.6317673,-1.1777027 4.9373508,-1.0542212 5.9714044,0.296884 6.4375963,0.9060152 7.3613203,1.9294988 8.1287599,2.3985951 9.7442268,3.3860466 10.594758,4.0411144 11.313517,5.4488065 Z",
			id: "path1"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 1.4092293,
			cy: 9.7382269,
			r: 3.0850697,
			id: "circle1",
			transform: "rotate(-27.048607)"
		})
	]
});
const ForwardRef = forwardRef(SvgKeto);
export default ForwardRef;
